
import EoNewsletterSubscribe from "../../EoNewsletterSubscribe/EoNewsletterSubscribe.vue"

export default {
  name: "PreprNewsletterSubscribe",
  components: { EoNewsletterSubscribe },
  props: {
    /**
     * Prepr data of this element
     */
    data: {
      type: Object,
      default: () => {},
    },
    /**
     * Prop and attribute overwrites
     */
    overwrites: {
      type: Object,
      default: () => {
        return {}
      },
    },
    /**
     * Index
     */
    index: {
      type: Number,
      default: null,
    },
  },
  data () {
    return {
      dataModel: {
        campaign: {
          items: [{
            id: null,
            body: null,
            description: null,
            image_url: null,
          }],
        },
        head:  {
          body: null,
        },
        intro:  {
          body: null,
        },
        ask_names: {
          body: null,
        },
        image: {
          items: [{
            cdn_files: {
              items: [{
                url: null,
              }],
            },
          }],
        },
      },
    }
  },
  computed: {
    normalizedData () {
      return {...this.dataModel, ...this.data}
    },
    // In a separate compute, because then we can use optional chaining and nullish coalescing
    askFullName() {
      return this.overwrites.askFullName ?? this.normalizedData.ask_names?.body === 'askFullName'
    },
    askFirstName() {
      return this.overwrites.askFirstName ?? ['askFullName', 'askName'].includes(this.normalizedData.ask_names?.body)
    },
    image() {
      return this.overwrites.image ?? this.normalizedData.image?.items[0]?.cdn_files.items[0]?.url
    },
  },
}
